import { PillLink } from "./PillLink";
import { routes } from "./landingContent";

/**
 * Closing CTA: full-bleed blue panel, headline left, supporting copy and the
 * sign-up button right-aligned on the right.
 */
export default function ClosingCTA() {
  return (
    <div className="mx-auto w-full max-w-[1440px] px-4 pt-[76px]">
      <div className="flex flex-col items-start justify-between gap-8 rounded-[28px] bg-eab-blue-dark px-6 py-12 text-white sm:px-10 lg:flex-row lg:items-center lg:gap-12 lg:px-14 lg:py-[68px]">
        <p className="max-w-[620px] text-pretty text-[36px] font-extrabold leading-[1.05] tracking-[-0.035em] lg:text-[52px]">
          Ready to start your journey?
        </p>
        <div className="flex flex-col items-start gap-[18px] lg:items-end">
          <p className="max-w-[380px] text-[19px] text-white/[0.88] lg:text-right">
            Join our community of entrepreneurs and mentors making meaningful connections.
          </p>
          <PillLink to={routes.signUp} variant="green">
            Get started today →
          </PillLink>
        </div>
      </div>
    </div>
  );
}
